// (C) Copyright 2025 Hewlett Packard Enterprise Development LP

import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Box } from 'grommet'
import { useNavigate } from 'react-router-dom'

import {
  ButtonGroup,
  ModalDialog,
  ModalFooter,
  ModalHeader,
  Typography
} from '../../../components'
import { isGLOP } from '../../../utils/feature-flag-utils'
import { AUDIT_LOG_CATEGORY } from '../../../utils/common-utils'

const OnpremAssignmentSuccessModal = ({ setSuccessNotification }) => {
  const { t } = useTranslation(['device', 'manage'])
  const navigate = useNavigate()
  const buttonList = [
    ...(!isGLOP()
      ? [
          {
            label: t('device:view_audit_log'),
            secondary: true,
            testId: 'view-audit-log-button',
            onClick: () => {
              navigate('/manage-account/auditlogs', {
                state: {
                  name: AUDIT_LOG_CATEGORY.DEVICE_MANAGEMENT
                }
              })
            }
          }
        ]
      : []),
    {
      label: t('device:close'),
      primary: true,
      testId: 'close-button',
      onClick: () => {
        setSuccessNotification(false)
      }
    }
  ]
  return (
    <ModalDialog
      width="medium"
      testId="onprem-assignment-success-modal-dialog"
      header={
        <ModalHeader
          subtitle={
            <Box margin={{ top: 'xsmall' }}>
              {t('manage:onprem_workspace.onprem_assignment_success_subtitle')}
            </Box>
          }
          title={
            <Typography
              level="2"
              style={{ whiteSpace: 'nowrap' }}
              testId="header-title"
              type="heading"
            >
              {t('manage:onprem_workspace.onprem_assignment_success_title')}
            </Typography>
          }
        />
      }
      footer={
        <ModalFooter
          right={
            <ButtonGroup
              buttonList={buttonList}
              testId="onprem-assignment-success-button"
            />
          }
        />
      }
      onClose={() => setSuccessNotification(false)}
    />
  )
}

OnpremAssignmentSuccessModal.propTypes = {
  setSuccessNotification: PropTypes.func.isRequired
}
export default OnpremAssignmentSuccessModal
